export default function ProductsSection() {
  return (
    <section id="products" className="py-28 md:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-stone-400 mb-4">
            <span className="w-4 h-px bg-stone-300" />
            Our Products
            <span className="w-4 h-px bg-stone-300" />
          </span>
          <h2 className="text-3xl md:text-5xl font-thin text-stone-900 leading-tight">
            Crafted for iOS.<br />
            <em className="not-italic font-light text-stone-400">Built for real people.</em>
          </h2>
        </div>

        {/* Product grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* VPN Card */}
          <div className="relative rounded-3xl overflow-hidden min-h-[480px] flex flex-col justify-end group">
            <img
              src="https://public.readdy.ai/ai/img_res/327b128aad9b099e56b7cab654f8e300.jpg"
              alt="VPN Application"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative z-10 p-8 md:p-10">
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1 mb-4">
                <i className="ri-shield-keyhole-line text-teal-400 text-sm" />
                <span className="text-white/80 text-xs font-medium tracking-wide">Security</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-semibold text-white mb-3">VPN Application</h3>
              <p className="text-white/70 text-sm leading-relaxed max-w-sm">
                A high-performance VPN for iOS that encrypts your connection, masks your identity, and keeps your data safe on any network — with zero-log policy and blazing-fast servers worldwide.
              </p>
              <ul className="mt-5 flex flex-wrap gap-2">
                {['256-bit Encryption', 'Zero Logs', 'Global Servers', 'Kill Switch'].map((f) => (
                  <li key={f} className="text-xs text-white/60 border border-white/20 rounded-full px-3 py-1">
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Cleaner Card */}
          <div className="flex flex-col gap-6">
            {/* Top */}
            <div className="relative rounded-3xl overflow-hidden min-h-[220px] flex flex-col justify-end group">
              <img
                src="https://readdy.ai/api/search-image?query=clean%20minimalist%20smartphone%20storage%20optimisation%20concept%2C%20soft%20warm%20cream%20and%20light%20sage%20green%20background%2C%20abstract%20geometric%20shapes%20representing%20organised%20files%20and%20freed%20space%2C%20modern%20flat%20art%20style%2C%20no%20text%2C%20airy%20and%20fresh%20aesthetic&width=700&height=300&seq=cleaner001&orientation=landscape"
                alt="Cleaner App"
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="relative z-10 p-7">
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1 mb-3">
                  <i className="ri-sparkling-line text-amber-300 text-sm" />
                  <span className="text-white/80 text-xs font-medium tracking-wide">Optimisation</span>
                </div>
                <h3 className="text-xl md:text-2xl font-semibold text-white mb-2">Cleaner App</h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  Reclaim storage, remove junk files, and keep your iPhone running at peak performance with intelligent automated cleaning.
                </p>
              </div>
            </div>

            {/* Bottom features split */}
            <div className="grid grid-cols-2 gap-6">
              {[
                {
                  icon: 'ri-delete-bin-6-line',
                  title: 'Smart Cleanup',
                  desc: 'Detects and removes duplicate photos, large files, and cached data automatically.',
                  bg: 'bg-stone-50',
                },
                {
                  icon: 'ri-speed-up-line',
                  title: 'Performance Boost',
                  desc: 'Frees RAM and optimises background processes for a snappier iOS experience.',
                  bg: 'bg-stone-900',
                  dark: true,
                },
              ].map((item) => (
                <div key={item.title} className={`rounded-3xl p-6 flex flex-col gap-4 ${item.bg}`}>
                  <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${item.dark ? 'bg-white/10' : 'bg-stone-200'}`}>
                    <i className={`${item.icon} text-lg ${item.dark ? 'text-white' : 'text-stone-600'}`} />
                  </div>
                  <div>
                    <h4 className={`text-sm font-semibold mb-1.5 ${item.dark ? 'text-white' : 'text-stone-900'}`}>{item.title}</h4>
                    <p className={`text-xs leading-relaxed ${item.dark ? 'text-white/60' : 'text-stone-500'}`}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
